import { render, staticRenderFns } from "./EditSpace.vue?vue&type=template&id=ec5ca326&"
import script from "./EditSpace.vue?vue&type=script&lang=js&"
export * from "./EditSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports